import PubSub from 'pubsub-js';
import { indexOf } from 'lodash';

const SCENES = ['index', 'about', 'strength', 'strength', 'strength', 'strength', 'news', 'team', 'insight', 'contact',];
const SCROLL_INTERVAL = 100;

const $html = $('html');
const $background = $('.background');

let scene = 0;
let timeoutId = null;
let isWheel = false;

const updateScene = (deltaY) => {
    if (deltaY > 0) {
        if (scene >= SCENES.length - 1) {
            $html.addClass('-fixed');
            return;
        }
        scene += 1;
    } else if (deltaY < 0) {
        if (scene <= 0) {
            return;
        }
        scene -= 1;
    } else {
        // 移動なし
        return;
    }
    const moveScene = SCENES[scene];
    const targetScene = $(`.background__item.-${moveScene}`).data('scene');
    $background.css('transform', `translateY(${targetScene * -100 * 2}vh)`);

    PubSub.publish('top.updateAnchorMenu', targetScene);
    PubSub.publish('top.updateScene', scene);
}

const pc = () => {
    const mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
    document.addEventListener(mousewheelevent, (e) => {
        if (!($html.hasClass('-fixed') || $html.hasClass('-isModal'))) {
            e.preventDefault();
        } else {
            return;
        }

        if (!isWheel) {
            const deltaY = e.deltaY;
            updateScene(deltaY);
        }

        isWheel = true;

        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
            isWheel = false;
    
        }, SCROLL_INTERVAL);
    }, { passive: false });
}

PubSub.subscribe('init', () => {
    const device = $html.data('device');
    if (device === 'pc') {
        pc();
    }
});

PubSub.subscribe('top.updateBackground', (msg, data) => {
    const targetScene = $(`.background__item.-${data}`).data('scene');
    $background.css('transform', `translateY(${targetScene * -100 * 2}vh)`);

    scene = indexOf(SCENES, data);

    PubSub.publish('top.updateAnchorMenu', targetScene);
    PubSub.publish('top.updateScene', scene);
});